import { makeExecutableSchema } from "@graphql-tools/schema";
import { withScalars } from 'apollo-link-scalars';
import typeDefs from '@/graphql/type-defs';
import './scalars/types';

// import Date from './scalars/Date';
import Decimal from './scalars/Decimal';
import DateTime from './scalars/DateTime';

// GraphQL Schema, required to use the link
const schema = makeExecutableSchema({
  typeDefs,
  resolvers: {
    // Date,
    Decimal,
    DateTime,
  },
});

export default withScalars({ schema });
